import { render, staticRenderFns } from "./HeaderSelector.vue?vue&type=template&id=66e38879"
import script from "./HeaderSelector.vue?vue&type=script&lang=js"
export * from "./HeaderSelector.vue?vue&type=script&lang=js"
import style0 from "./HeaderSelector.vue?vue&type=style&index=0&id=66e38879&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports